import { marked } from "marked";

// Guide sections are GitHub-flavoured markdown. Raw HTML in them is shown as
// text, not rendered, so what reaches dangerouslySetInnerHTML is only what
// marked itself emits.
const escapeHtml = (text: string) =>
  text.replace(/[&<>"']/g, (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[char]!);

marked.use({ renderer: { html: ({ text }) => escapeHtml(text) } });

/**
 * Markdown to HTML. Task-list boxes become live checkboxes numbered in
 * document order (data-checkbox), checked as the player left them; tables
 * get a scrolling wrapper.
 */
export function renderMarkdown(markdown: string, savedCheckboxState: Record<string, boolean>): string {
  const doc = new DOMParser().parseFromString(marked.parse(markdown, { async: false }), "text/html");
  doc.querySelectorAll("table").forEach((table) => {
    const wrap = doc.createElement("div");
    wrap.className = "table-wrap";
    table.replaceWith(wrap);
    wrap.append(table);
  });
  doc.querySelectorAll<HTMLInputElement>('li > input[type="checkbox"]').forEach((input, index) => {
    const item = input.parentElement!;
    const label = doc.createElement("label");
    label.className = "check";
    const text = doc.createElement("span");
    const nodes = Array.from(item.childNodes).filter((node) => node !== input);
    if (nodes[0]?.nodeType === Node.TEXT_NODE) nodes[0].textContent = nodes[0].textContent!.trimStart();
    text.append(...nodes);
    const checkedInFile = input.hasAttribute("checked");
    input.removeAttribute("disabled");
    input.removeAttribute("checked");
    input.dataset.checkbox = String(index);
    if (savedCheckboxState[index] ?? checkedInFile) input.setAttribute("checked", "");
    label.append(input, text);
    item.replaceChildren(label);
  });
  return doc.body.innerHTML;
}
